import { ButtonDesktop as Button } from '@tui-react/button';
import { formatDuration, intervalToDuration } from 'date-fns';
import ru from 'date-fns/locale/ru';
import React from 'react';
import ReactDOM from 'react-dom';
import { FormattedMessage as Message } from 'react-intl';
import StopWatchIcon from '../../assets/icons/stopwach.svg';
import useRootElement from '../../hooks/useRootElement';
import intl from '../../locale';
import styles from './GlobalTimerOverlay.module.css';

export const GlobalTimerOverlay: React.FC<{
  onStartGlobalTimer: () => void;
  timeDurationSec?: number;
  timerStrict?: boolean;
}> = ({ onStartGlobalTimer, timeDurationSec = 0, timerStrict }) => {
  const { element } = useRootElement();

  const duration = intervalToDuration({ start: 0, end: timeDurationSec * 1000 });

  const formattedTime = formatDuration(duration, { locale: ru });

  return ReactDOM.createPortal(
    <div id="content">
      <section className={styles.root}>
        <div className={styles.icon}>
          <img src={StopWatchIcon} alt={'Иконка таймера'} />
        </div>

        <span className={styles.headerText}>
          <Message id={'PageTimer.PlugTitle1'} />
          <br />
          <Message id={'PageTimer.PlugTitle2'} values={{ formattedTime }} />
          <br />
          <Message id={'PageTimer.PlugTitle3'} />
        </span>
        <span className={styles.footerText}>
          <Message
            id={'PageTimer.PlugDescription'}
            values={{
              timerStrict: timerStrict
                ? intl.formatMessage({ id: 'PageTimer.StrictDescription' })
                : intl.formatMessage({ id: 'PageTimer.NonStrictDescription' }),
            }}
          />
        </span>
        <div className={styles.button}>
          <Button size={'m'} type={'button'} onClick={onStartGlobalTimer}>
            <Message id={'System.StartPoll'} />
          </Button>
        </div>
      </section>
    </div>,
    element,
  );
};
